import { getFormInputComponent } from './Utils';
import { useEffect, useState } from 'react';
import { FieldErrors, Control } from 'react-hook-form/dist/types/form';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import { Contact } from '@ssar-app/domain';

interface ContactDetailsProps {
  propName: string;
  errors?: FieldErrors<Contact>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  model?: Contact;
  onChange?: (contact: Contact) => void;
  isReadOnly?: boolean;
  clearErrors: (name?: string | string[] | undefined) => void;
}

export const ContactDetails = (props: ContactDetailsProps) => {
  const { propName, errors, control, model } = props;
  const [contact, setContact] = useState(model);
  const isReadOnly = props.isReadOnly === true;

  useEffect(() => {
    setContact(model);
  }, [model]);

  return (
    <Flex flexDir='column' gap={6} ml={20}>
      <FormControl isInvalid={!!errors?.name}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}name`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Contact Name :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3}>
            {getFormInputComponent(
              `${propName}name`,
              control,
              contact?.name || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.name?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.clientName}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex' colSpan={1}>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}clientName`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Company Name :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3}>
            {getFormInputComponent(
              `${propName}clientName`,
              control,
              contact?.clientName || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.clientName?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.email}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}email`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Email :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}email`,
              control,
              contact?.email || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.email?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.address}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}address`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Address :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}address`,
              control,
              contact?.address || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.address?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.city}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}city`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              City :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}city`,
              control,
              contact?.city || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.city?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.state}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}state`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              State :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}state`,
              control,
              contact?.state || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.state?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.zipCode}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}zipCode`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Zip Code :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}zipCode`,
              control,
              contact?.zipCode || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.zipCode?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
      <FormControl isInvalid={!!errors?.phoneNumber}>
        <Grid templateColumns='repeat(4,1fr)'>
          <GridItem justifyContent='end' display='flex'>
            <FormLabel
              fontSize='md'
              htmlFor={`${propName}phoneNumber`}
              mb={0}
              mr={2}
              mt='-2px'
            >
              Phone Number :
            </FormLabel>
          </GridItem>
          <GridItem colSpan={3} alignSelf={'center'}>
            {getFormInputComponent(
              `${propName}phoneNumber`,
              control,
              contact?.phoneNumber || '',
              isReadOnly,
              '',
              '',
            )}
            <FormErrorMessage>{errors?.phoneNumber?.message}</FormErrorMessage>
          </GridItem>
        </Grid>
      </FormControl>
    </Flex>
  );
};
